export { AgeRestrictionBlock, type AgeRestrictionBlockProps } from './age-restriction-block';
